import { create } from 'zustand'
import { messagingService } from '../services/messagingService'
import { serviceRequestService } from '../services/serviceRequestService'

interface NotificationState {
  unreadMessageCount: number
  collaborationBadgeCount: number
  collaborationTabCounts: Record<string, number>
  fetchCounts: () => Promise<void>
  startPolling: () => void
  stopPolling: () => void
}

let pollingInterval: ReturnType<typeof setInterval> | null = null

export const useNotificationStore = create<NotificationState>((set, get) => ({
  unreadMessageCount: 0,
  collaborationBadgeCount: 0,
  collaborationTabCounts: {},

  fetchCounts: async () => {
    try {
      const [messageData, badgeData] = await Promise.all([
        messagingService.getUnreadCount(),
        serviceRequestService.getBadgeCounts(),
      ])
      set({
        unreadMessageCount: messageData.unread_count,
        collaborationBadgeCount: badgeData.total || 0,
        collaborationTabCounts: badgeData,
      })
    } catch {
      // Silently fail — badges are non-critical
    }
  },

  startPolling: () => {
    // Fetch immediately
    get().fetchCounts()
    // Set up interval (avoid duplicates)
    if (!pollingInterval) {
      pollingInterval = setInterval(() => {
        get().fetchCounts()
      }, 60000)
    }
  },

  stopPolling: () => {
    if (pollingInterval) {
      clearInterval(pollingInterval)
      pollingInterval = null
    }
  },
}))
